/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type SbRespComponents_user = {
    readonly " $fragmentRefs": FragmentRefs<"TradePromo_user" | "SbRespNullSearchResults_user" | "SbRespFollowSearchBanner_user" | "SbRespFollowSearchTopButton_user" | "SbSharedFollowSearchProvider_user" | "SharedRecentlyViewedItems_user" | "SbRespMainContent_user" | "SuspectedTradeUserLoader_user">;
    readonly " $refType": "SbRespComponents_user";
};
export type SbRespComponents_user$data = SbRespComponents_user;
export type SbRespComponents_user$key = {
    readonly " $data"?: SbRespComponents_user$data;
    readonly " $fragmentRefs": FragmentRefs<"SbRespComponents_user">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "SbRespComponents_user",
  "type": "User",
  "metadata": null,
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "isTrade",
      "type": "Boolean"
    }
  ],
  "selections": [
    {
      "kind": "Condition",
      "passingValue": true,
      "condition": "isTrade",
      "selections": [
        {
          "kind": "FragmentSpread",
          "name": "TradePromo_user",
          "args": null
        }
      ]
    },
    {
      "kind": "FragmentSpread",
      "name": "SbRespNullSearchResults_user",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "SbRespFollowSearchBanner_user",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "SbRespFollowSearchTopButton_user",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "SbSharedFollowSearchProvider_user",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "SharedRecentlyViewedItems_user",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "SbRespMainContent_user",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "SuspectedTradeUserLoader_user",
      "args": null
    }
  ]
};
(node as any).hash = 'b23dbdd8e8332b0dc98e23a52b11a8c9';
export default node;
